var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.items, function(item) {
      return _c("check-box", {
        key: item.name,
        staticClass: "box-item",
        attrs: {
          boldLabels: _vm.boldLabels,
          customFontSize: _vm.customFontSize,
          active: _vm.activeBoxes,
          label: item.label,
          value: item.value,
          name: item.name
        },
        on: { select: _vm.boxSelect }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6a24920", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6a24920","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/form/FormCheckbox.vue
// module id = null
// module chunks = 